import { render } from "./TagAdd.vue?vue&type=template&id=ac67f616"
import script from "./TagAdd.vue?vue&type=script&lang=js"
export * from "./TagAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__